<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        style="width: 100%; margin-top: 60px; background-color: #ffedc3"
        class='reduced-margin-top'
      >
        <b-col
          cols="12"
          style="padding-top: 5px"
          class="pl-0 pr-0 cart-nav-bundle"
        >
          <b-row style="">
            <b-col
              class="pl-pr-0-sm pb-5"
              cols="12"
              style="
                background-color: #ffedc3;
                padding-left: 5%;
                padding-right: 5%;
              "
            >
              <b-row class="pt-5" data-aos="fade-right" data-aos-delay="250">
                <b-col
                  class="hero-text-sm"
                  style="
                    color: #feb60d;
                    font-weight: 700;
                    max-width: 1080px;
                    margin: 0 auto;
                    font-size:24px;
                  "
                >
                  Multi-User Bundles
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col
                  style="
                    font-size: 16px;
                    color: #45484b;
                    max-width: 1080px;
                    margin: 0 auto;
                  "
                >
                  One payment. Unlimited service.
                </b-col>
              </b-row>

              <b-row class="pb-5 pl-3 pr-3">
                <b-col
                  cols="12"
                  class="pt-4 pb-4 pl-0 pr-0"
                  v-for="(item, index) in inventory_pro"
                  :key="index"
                  style="max-width: 1080px; margin: 0 auto"
                >
                  <b-row>
                    <b-col style="background-color: white; border-radius: 10px">
                      <b-row class="pt-4">
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 0"
                        >
                          <span style="color: #2f95eb">Pro Tracker </span> Bundle
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 1"
                        >
                          <span style="color: #2f95eb">Classic Tracker </span> Bundle
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 2"
                        >
                          <span style="color: #2f95eb">Skin </span> Collection
                        </b-col>
                        <b-col
                          class="bundle-h1 align-center-small"
                          v-if="index == 3"
                        >
                          <span style="color: #2f95eb"
                            >New Classic Tracker</span
                          >
                          + <span style="color: #00bea4">Hub</span> Bundle
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          class="pt-2 pb-3 align-center-small pl-pr-0-sm"
                          style="font-size: 15px"
                        >
                          {{ inventory_pro[index].h1 }}
                        </b-col>
                      </b-row>
                      <b-row class="pb-5">
                        <b-col md="6" cols="12" class="hide-when-small">
                          <b-row>
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's in the Bundle?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 1 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2">
                            <b-col
                              cols="8"
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col md="6" cols="12" class="pl-0 pr-0">
                          <b-row v-if="item.list.length > 1" class="pt-2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436">
                                Select number of
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 0"
                              >
                                Pro Trackers
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                v-if="index == 1"
                              >
                                Classic Trackers
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="item.list.length > 1">
                            <b-col
                              style=""
                              md="3"
                              cols="12"
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_size_img"
                                style="cursor: pointer"
                                :class="{
                                  'selected-border': index2 == item.index1,
                                }"
                                class="unselected-border"
                                @click="select_bundle_size(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-if="index == 0"
                                >Skin</span
                              >
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-else
                                >Design</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              md="3"
                              cols="12"
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list[item.index1]
                                .skus"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_skin_img"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == item.index2,
                                }"
                                @click="select_bundle_design(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3" v-if="index != 2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span style="color: #00bea4" class="pl-2 pr-2"
                                >Hub</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="index != 2" class="pb-2">
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 0"
                            >
                              Truthbrush Hub with USB plug. Automatically connects with multiple trackers. Adaptor not included.
                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 1"
                            >
                              Add a Type A compatible USB power adapter to conveniently plug into a wall outlet (For US, Canada, Mexico, Others)

                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 2"
                            >
                              Add a Type I compatible USB power adapter to conveniently plug into a wall outlet (For Australia, Others)

                            </b-col>
                          </b-row>
                          <b-row v-if="index != 2">
                            <b-col
                              style=""
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in hub_type"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.image"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == adaptor,
                                }"
                                @click="select_bundle_hub(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2">
                            <hr style="width: 100%; height: 1px" />
                          </b-row>
                          <b-row
                            v-if="
                              getCoupon() == 'babysideburns' ||
                              getCoupon() == 'A3KzVdj8'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Baby Sideburns Sale!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="
                              getCoupon() == 'peachjar0427'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Extra 20% off for LexRich5!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="
                              getCoupon() == 'dV7sL3vU'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #2F95EB;
                                text-align: center;
                              "
                            >
                              Flash Sale, Extra 10% Off
                            </b-col>
                          </b-row>


                          <b-row
                            v-if="getCoupon() == '5minutesformom'"
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              5 Minutes for Mom Special Price!
                            </b-col>
                          </b-row>
                          <b-row v-if="getCoupon() == 'Sixfr2n3'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Black Friday Sale - Extra 15% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="getCoupon() == 'mylifesuckers'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              MyLifeSuckers - Extra 10% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="getCoupon() == 'TDm1cVpj'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Holiday Sales! - Extra 10% Off
                            </b-col>
                          </b-row>
                          
                          <b-row v-if="calculateFinalPrice(100) == 100">
                            <b-col
                              style="color: #1f2122; font-size: 27px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ getPrice(index, 1) }} (${{
                                getPrice(index, 0)
                              }}
                              value)
                            </b-col>
                          </b-row>

                          <b-row v-else>
                            <b-col
                              style="color: #1f2122; font-size: 25px"
                              class="align-center-small pl-0 pr-0"
                            >
                              ${{ calculateFinalPrice(getPrice(index, 1)) }}

                              <strike>${{ getPrice(index, 0) }}</strike>
                              ({{
                                (
                                  (1 -
                                    calculateFinalPrice(getPrice(index, 1)) /
                                      getPrice(index, 0)) *
                                  100
                                ).toFixed(0)
                              }}% Off)
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 pb-1 pl-0 reduced_pl_pr" style='cursor:pointer' @click="gotoSubscription()" v-if='index!=2'  hidden>
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3 pl-pr-0-sm"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/payg-logo.png"
                                    style="max-width: 40px"
                                    center
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-1 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        See new, flexible monthly plans!</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col
                                      cols="pl-0 pr-1"
                                      style="max-width: 380px"
                                    >
                                      Start for less. Then, pay as low as 99&#162;/mo/user. Cancel any time.
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2 pb-1 pl-0 reduced_pl_pr">
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3 pr-0"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr pl-0 pr-1"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/tb-ic-paypal@2x.png"
                                    style="max-width: 35px"
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-0 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        Buy Now, Pay Later with PayPal</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-if="calculateFinalPrice(100) == 100"
                                        >4 interest-free payments of ${{
                                          (getPrice(index, 1) / 4.0).toFixed(2)
                                        }}</b
                                      >
                                      <b
                                        style="font-size: 14px; color: #c84141"
                                        v-else
                                        >4 interest-free payments of ${{
                                          (
                                            calculateFinalPrice(
                                              getPrice(index, 1)
                                            ) / 4.0
                                          ).toFixed(2)
                                        }}</b
                                      >
                                      <b class="hide-when-small">
                                        with Pay in 4</b
                                      >
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col cols="12" class="pl-0 pr-0 pt-3">
                              <b-button
                                pill
                                class="blue-button max-width-sm"
                                style="width: 100%; height: 40px"
                                v-on:click="
                                  onAddCart2(
                                    item,
                                    item.index1,
                                    item.index2,
                                    item.index3
                                  )
                                "
                              >
                                <span style="font-size: 18px">Add to Cart</span>
                              </b-button>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-if="index == 2"
                            >
                              Free US Shipping ($50 or above) | Ship Worldwide
                            </b-col>
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-else
                            >
                              Free US Shipping | Ship Worldwide
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                            >
                              Factory Warranty | 30 Day Guarantee
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col
                          md="6"
                          cols="12"
                          class="pl-pr-0-sm pt-3 hide-when-big"
                        >
                          <b-row class="pt-2">
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's in the Bundle?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 1 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index<2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                                max-width: 340px;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                          <b-row class="pt-3 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-if="index == 2"
                            >
                              Free US Shipping Above $50 | Ship Worldwide
                            </b-col>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-else
                            >
                              Free US Shipping | Ship Worldwide
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                            >
                              Factory Warranty | 30 Day Guarantee
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import CheckoutExpress from "./../components/CheckoutExpress";
import storage from "../storage";
import store from "../store";
import env from "../env";
export default {
  name: "Bundle",
  components: {
    NavHeader,
    NavFooter,
    CheckoutExpress,
  },
  data() {
    return {
      show: false,
      adaptor: 0,
      hub_type: [
        {
          image: "/img/products/travel_hub.png",
        },

        {
          image: "/img/products/hub_adaptor_type_1.png",
        },

        {
          image: "/img/products/hub_adaptor_type_i.png",
        },
      ],
      inventory_pro: [
        {
          h1: "Battery Replaceable | Data Hub | Skins",
          index1: 0,
          index2: 0,
          index3: 0,
          list: [
            {
              h2: "2 Pro Tracker Unlimited Bundle",
              tracker_size_img: "/img/products/bundle_pro_2.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_0b",
                      base_price: 74.97,
                      list_price: 69.99,
                      h3: "2 Pro Trackers | No Skin | 1 Hub",
                      image: "/img/products/2_pro_0b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Dinosaur_Unicorn.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_1b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Dinosaur, Unicorn) | 1 Hub",
                      image: "/img/products/2_pro_1b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Astronaut_Flamingo.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_2b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Astronaut, Flamingo) | 1 Hub",
                      image: "/img/products/2_pro_2b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Monster_Truck_Foxcream.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_3b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Monster Truck, Foxcream) | 1 Hub",
                      image: "/img/products/2_pro_3b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Panda_Peacock.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_4b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Panda, Peacock) | 1 Hub",
                      image: "/img/products/2_pro_4b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Orca_Heart.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_5b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Orca, Heart) | 1 Hub",
                      image: "/img/products/2_pro_5b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Mermaid_Daisy.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_pro_opt_6b",
                      base_price: 84.95,
                      list_price: 74.99,
                      h3: "2 Pro Trackers | 2 Skins (Mermaid, Daisy) | 1 Hub",
                      image: "/img/products/2_pro_6b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "3 Pro Tracker Unlimited Bundle",
              tracker_size_img: "/img/products/bundle_pro_3.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_1b",
                      base_price: 104.96,
                      list_price: 89.99,
                      h3: "3 Pro Trackers | No Skin | 1 Hub",
                      image: "/img/products/3_pro_bundle_no_skin.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/USA_Flag_Monster_Truck_Baseball_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_2b",
                      base_price: 119.93,
                      list_price: 99.99,
                      h3: "3 Pro Trackers | 3 Skins (Flag, Monster Truck, Baseball) | 1 Hub",
                      image: "/img/products/3_pro_2b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Dinosaur_Football_Heart_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_3b",
                      base_price: 119.93,
                      list_price: 99.99,
                      h3: "3 Pro Trackers | 3 Skins (Dinosaur, Football, Heart) | 1 Hub",
                      image: "/img/products/3_pro_3b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Unicorn_Flamingo_Orange_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_4b",
                      base_price: 119.93,
                      list_price: 99.99,
                      h3: "3 Pro Trackers | 3 Skins (Unicorn, Flamingo, Orange) | 1 Hub",
                      image: "/img/products/3_pro_4b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Monster_Truck_Unicorn_Penguin_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_5b",
                      base_price: 119.93,
                      list_price: 99.99,
                      h3: "3 Pro Trackers | 3 Skins (Monster Truck, Unicorn, Penguin) | 1 Hub",
                      image: "/img/products/3_pro_5b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Owl_Axo_Astronaut.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_pro_opt_6b",
                      base_price: 119.93,
                      list_price: 99.99,
                      h3: "3 Pro Trackers | 3 Skins (Snowy Owl, Axolotl, Astronaut) | 1 Hub",
                      image: "/img/products/3_pro_6b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "4 Pro Tracker Unlimited Bundle",
              tracker_size_img: "/img/products/bundle_pro_4.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_1b",
                      base_price: 134.95,
                      list_price: 109.99,
                      h3: "4 Pro Trackers | No Skin | 1 Hub",
                      image: "/img/products/4_pro_bundle_no_skin.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Surfing_Football_USA_Flag_Panda_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_2b",
                      base_price: 154.91,
                      list_price: 119.99,
                      h3: "4 Pro Trackers | 4 Skins (Surfing, Football, USA_Flag, Panda) | 1 Hub",
                      image: "/img/products/4_pro_2b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Astronaut_Unicorn_Baseball_Peacock_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_3b",
                      base_price: 154.91,
                      list_price: 119.99,
                      h3: "4 Pro Trackers | 4 Skins (Astronaut, Unicorn, Baseball, Peacock) | 1 Hub",
                      image: "/img/products/4_pro_3b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img:
                    "/img/products/Dinosaur_Flamingo_Orange_Heart_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_4b",
                      base_price: 154.91,
                      list_price: 119.99,
                      h3: "4 Pro Trackers | 4 Skins (Dinosaur, Flamingo, Orange, Heart) | 1 Hub",
                      image: "/img/products/4_pro_4b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img:
                    "/img/products/Griffin_MonkeyKing_Bunny_Foxcream.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_pro_opt_5b",
                      base_price: 154.91,
                      list_price: 119.99,
                      h3: "4 Pro Trackers | 4 Skins (Griffin, Monkey King, Bunny, Foxcream) | 1 Hub",
                      image: "/img/products/4_pro_5b.png",
                    },
                  ],
                },
              ],
            },

            {
              h2: "5 Pro Tracker Unlimited Bundle",
              tracker_size_img: "/img/products/bundle_pro_5.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_5_pro_opt_1b",
                      base_price: 164.94,
                      list_price: 129.99,
                      h3: "5 Pro Trackers | No Skin | 1 Hub",
                      image: "/img/products/5_pro_1b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/5_random_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_5_pro_opt_2b",
                      base_price: 189.89,
                      list_price: 139.99,
                      h3: "5 Pro Trackers | Assorted Skins (Random) | 1 Hub",
                      image: "/img/products/5_pro_2b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "6 Pro Tracker Unlimited Bundle",
              tracker_size_img: "/img/products/bundle_pro_6.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_6_pro_opt_1b",
                      base_price: 194.93,
                      list_price: 149.99,
                      h3: "6 Pro Trackers | No Skin | 1 Hub",
                      image: "/img/products/6_pro_1b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/6_random_skin.png",
                  opt: [
                    {
                      skuid: "sku_bundle_6_pro_opt_2b",
                      base_price: 224.87,
                      list_price: 159.99,
                      h3: "6 Pro Trackers | Assorted Skins (Random) | 1 Hub",
                      image: "/img/products/6_pro_2b.png",
                    },
                  ],
                },
              ],
            },
          ],
        },

        // new T1 logo skin
        {
          h1: "1 Year Built-in Battery | Data Hub",
          index1: 0,
          index2: 0,
          index3: 0,
          list: [
            {
              h2: "2 Classic Tracker Bundle",
              tracker_size_img: "/img/products/bundle_classic_2.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/new_classic_2_t1_1.png",
                  opt: [
                    {
                      skuid: "sku_bundle_2_new_classic_opt_1b",
                      base_price: 64.97,
                      list_price: 59.99,
                      h3: "2 Classic Trackers (1 year battery) | Blue, Yellow | 1 Hub",
                      image: "/img/products/new_classic_2_t1_1_travel.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "3 Classic Tracker Bundle",
              tracker_size_img: "/img/products/bundle_classic_3.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/new_classic_3_t1_1.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_new_classic_opt_1b",
                      base_price: 89.96,
                      list_price: 79.99,
                      h3: "3 Classic Trackers (1 year battery) | Blue, Blue, Blue | 1 Hub",
                      image: "/img/products/new_classic_3_t1_1_travel.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/new_classic_3_t1_2.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_new_classic_opt_2b",
                      base_price: 89.96,
                      list_price: 79.99,
                      h3: "3 Classic Trackers (1 year battery) | Yellow, Yellow, Yellow | 1 Hub",
                      image: "/img/products/new_classic_3_t1_2_travel.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/new_classic_3_t1_3.png",
                  opt: [
                    {
                      skuid: "sku_bundle_3_new_classic_opt_3b",
                      base_price: 89.96,
                      list_price: 79.99,
                      h3: "3 Classic Trackers (1 year battery) | Blue, Blue, Yellow | 1 Hub",
                      image: "/img/products/new_classic_3_t1_3_travel.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "4 Classic Tracker Bundle",
              tracker_size_img: "/img/products/bundle_classic_4.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/new_classic_4_t1_1.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_new_classic_opt_1b",
                      base_price: 114.95,
                      list_price: 99.99,
                      h3: "4 Classic Trackers (1 year battery) | Blue, Blue, Blue, Blue | 1 Hub",
                      image: "/img/products/new_classic_4_t1_1_travel.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/new_classic_4_t1_2.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_new_classic_opt_2b",
                      base_price: 114.95,
                      list_price: 99.99,
                      h3: "4 Classic Trackers (1 year battery) | Yellow, Yellow, Yellow, Yellow | 1 Hub",
                      image: "/img/products/new_classic_4_t1_2_travel.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/new_classic_4_t1_3.png",
                  opt: [
                    {
                      skuid: "sku_bundle_4_new_classic_opt_3b",
                      base_price: 114.95,
                      list_price: 99.99,
                      h3: "4 Classic Trackers (1 year battery) | Blue, Blue, Yellow, Yellow | 1 Hub",
                      image: "/img/products/new_classic_4_t1_3_travel.png",
                    },
                  ],
                },
              ],
            },
          ],
        },

        // skin bundle
        {
          h1: "Our most popular Skins. Fit for both Tracker Pro and Classic Tracker models. Give your Tracker a new look!",
          index1: 0,
          index2: 1,
          index3: 0,
          list: [
            {
              h2: "Skin collections",
              tracker_size_img: "/img/products/bundle_pro_3.png",
              tracker_size_hide: true,
              skus: [
                {
                  tracker_skin_img: "/img/products/skin_collection_1.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_1",
                      base_price: 34.93,
                      list_price: 23.74,
                      h3: "The classic-7 Skin Bundle | Unicorn, Astronaut, Peacock, Orange, Heart, Dinosaur, Flamingo",
                      image: "/img/products/skin_collection_1.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_3.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_3",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Penguin, Foxcream, Peacock, Flamingo, Unicorn, Panda",
                      image: "/img/products/skin_collection_3.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_4.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_4",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Astronaut, Dinosaur, Baseball, Football, Flag, Monster Truck",
                      image: "/img/products/skin_collection_4.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/skin_collection_5.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_5",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Mermaid, Griffin, Daisy, Peacock, Panda, Orange",
                      image: "/img/products/skin_collection_5.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/skin_collection_6.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_6",
                      base_price: 29.94,
                      list_price: 21.99,
                      h3: "6 Skin Bundle | Monkey King, Orca, Snowy Owl, Axolotl, Penguin, Monster Truck",
                      image: "/img/products/skin_collection_6.png",
                    },
                  ],
                },
                /*
                {
                  tracker_skin_img: "/img/products/skin_collection_2.png",
                  opt: [
                    {
                      skuid: "sku_bundle_skin_collection_opt_2",
                      base_price: 63.85,
              list_price: 51.08,
                      h3: "All 15 Skins | Unicorn, Astronaut, Peacock, Orange, Heart, Dinosaur, Flamingo, Baseball, Football, Foxcream, Monster Truck, Panda, Penguin, Surfboard, Flag",
                      image: "/img/products/skin_collection_2.png",
                    },
                  ],
                },
                */
              ],
            },
          ],
        },
        //{},
      ],
      inventory: [
        {
          h1: "2 Pro Tracker + Hub Bundle",
          h2: "Includes 2 Pro Trackers, 1 Hub and 2 Skins. Ready to use.",
          index: 2,
          list: [
            {
              h3: "Dinosaur, Unicorn",
              skuid: "sku_bundle_2_pro_opt_1",
              base_price: 72.95,
              list_price: 67.84,
              image: "/img/products/2_pro_1.png",
            },
            {
              h3: "Astronaut, Flamingo",
              skuid: "sku_bundle_2_pro_opt_2",
              base_price: 72.95,
              list_price: 67.84,
              image: "/img/products/2_pro_2.png",
            },
            {
              h3: "Monster Truck, Foxcream",
              skuid: "sku_bundle_2_pro_opt_3",
              base_price: 73.95,
              list_price: 68.77,
              image: "/img/products/2_pro_3.png",
            },
            {
              h3: "Panda, Peacock",
              skuid: "sku_bundle_2_pro_opt_4",
              base_price: 72.95,
              list_price: 67.84,
              image: "/img/products/2_pro_4.png",
            },
          ],
        },

        {
          h1: "3 Pro Tracker + Hub Bundle",
          h2: "Includes 3 Pro Trackers, each with replaceable battery, and 1 Hub. Ready to use.",
          index: 0,
          list: [
            {
              h3: "No Skin",
              skuid: "sku_bundle_3_pro_opt_1",
              base_price: 89.96,
              list_price: 79.99,
              image: "/img/products/3_pro_1.png",
            },
            {
              h3: "Flag, Monster Truck, Baseball",
              skuid: "sku_bundle_3_pro_opt_2",
              base_price: 102.93,
              list_price: 89.54,
              image: "/img/products/3_pro_2.png",
            },
            {
              h3: "Dinosaur, Football, Heart",
              skuid: "sku_bundle_3_pro_opt_3",
              base_price: 101.93,
              list_price: 88.67,
              image: "/img/products/3_pro_3.png",
            },
            {
              h3: "Unicorn, Flamingo, Orange",
              skuid: "sku_bundle_3_pro_opt_4",
              base_price: 101.93,
              list_price: 88.67,
              image: "/img/products/3_pro_4.png",
            },
            {
              h3: "Penguin, Monster Truck, Unicorn",
              skuid: "sku_bundle_3_pro_opt_5",
              base_price: 102.93,
              list_price: 89.54,
              image: "/img/products/3_pro_5.png",
            },
          ],
        },
        {
          h1: "4 Pro Tracker + Hub Bundle",
          h2: "Includes 4 Pro Trackers, each with replaceable battery, and 1 Hub. Ready to use.",
          index: 1,
          list: [
            {
              h3: "No Skin",
              skuid: "sku_bundle_4_pro_opt_1",
              base_price: 114.95,
              list_price: 99.99,
              image: "/img/products/4_pro_1.png",
            },
            {
              h3: "Surfboard, Football, Flag, Panda",
              skuid: "sku_bundle_4_pro_opt_2",
              base_price: 132.91,
              list_price: 109.78,
              image: "/img/products/4_pro_2.png",
            },
            {
              h3: "Astronaut, Unicorn, Baseball, Peacock",
              skuid: "sku_bundle_4_pro_opt_3",
              base_price: 130.91,
              list_price: 107.78,
              image: "/img/products/4_pro_3.png",
            },
            {
              h3: "Dinosaur, Flamingo, Orange, Heart",
              skuid: "sku_bundle_4_pro_opt_4",
              base_price: 130.91,
              list_price: 107.78,
              image: "/img/products/4_pro_4.png",
            },
          ],
        },
        {
          h1: "4 Classic Tracker + Hub Bundle",
          h1b: "3 Classic Tracker + Hub Bundle",
          h2: "Includes 4 Classic Trackers, each with 6 months built-in battery, and 1 Hub. Ready to use.",
          h2b: "Includes 3 Classic Trackers, each with 6 months built-in battery, and 1 Hub. Ready to use.",
          index: 0,
          list: [
            {
              h3: "Unicorn, Astronaut, Peacock",
              skuid: "sku_bundle_3_classic_opt_1",
              base_price: 62.96,
              list_price: 56.66,
              image: "/img/products/3_classic_1.png",
            },
            {
              h3: "Dinosaur, Flamingo, Orange",
              skuid: "sku_bundle_3_classic_opt_2",
              base_price: 62.96,
              list_price: 56.66,
              image: "/img/products/3_classic_2.png",
            },
            {
              h3: "Flamingo, Astronaut, Peacock, Heart",
              skuid: "sku_bundle_4_classic_opt_1",
              base_price: 78.95,
              list_price: 69.48,
              image: "/img/products/4_classic_1.png",
            },
            {
              h3: "Unicorn, Dinosaur, Heart, Orange",
              skuid: "sku_bundle_4_classic_opt_2",
              base_price: 78.95,
              list_price: 69.48,
              image: "/img/products/4_classic_2.png",
            },
          ],
        },

        {
          h1: "Skin Collections",
          h2: "Fit for both Tracker Pro and Classic Tracker models",
          index: 0,
          list: [
            {
              h3: "The Classic 7",
              skuid: "sku_bundle_skin_collection_opt_1",
              base_price: 27.93,
              list_price: 23.74,
              image: "/img/products/skin_collection_1.png",
            },
            {
              h3: "All Collection (15)",
              skuid: "sku_bundle_skin_collection_opt_2",
              base_price: 63.85,
              list_price: 51.08,
              image: "/img/products/skin_collection_2.png",
            },
          ],
        },
      ],
    };
  },
  methods: {
    gotoSubscription(){
        window.location.href = "/#/select_t6";
    },
    select_bundle_size(item, index2) {
      item.index1 = index2;
      item.index2 = 0;
      item.index3 = 0;
    },
    select_bundle_design(item, index) {
      item.index2 = index;
    },
    select_bundle_hub(item, index) {
      //item.index3 = index;
      this.adaptor = index;
    },
    getSelectHubClass(item, index) {
      if (item.index3 == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    clicksku_hub(item, index) {
      item.index3 = index;
    },
    getImage(item) {
      return item.list[item.index].image;
    },
    getImage2(item) {
      return item.list[item.index1].skus[item.index2].opt[item.index3].image;
    },
    getImage3(item, index) {
      return item.opt[index].image;
    },
    getPrice(index, mode) {
      var index1 = this.inventory_pro[index].index1;
      var index2 = this.inventory_pro[index].index2;
      var index3 = this.inventory_pro[index].index3;

      var adaptorloading = 0;
      if (this.adaptor > 0) {
        adaptorloading = 4.99;
      }

      if (mode == 0) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .base_price + adaptorloading
        ).toFixed(2);
      } else if (mode == 1) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .list_price + adaptorloading
        ).toFixed(2);
      }
    },
    getH3(item, i) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      var list = str.split("|");
      if (list.length > i) {
        return list[i].trim();
      } else {
        return "";
      }
    },
    getH4(item) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      if (str.toLowerCase().includes("skin bundle")) {
        return "Designed for both Pro and Classic trackers";
      }
      var list = str.split("|");
      if (list.length > 0) {
        var first = list[0].split(" ")[0];
        return (
          "Ready for " +
          first +
          " users. App free to use. Support all types of toothbrushes, manual or electric."
        );
      } else {
        return "Ready to use. App is free.";
      }
    },
    selectsku(a, b) {
      this.inventory[a].index = b;
    },
    selectsku1(item, index1, index2) {
      item.index1 = index1;
      item.index2 = index2;
    },
    calculateFinalPrice(p) {
      var new_p = p * (1 - store.state.discount_percent);
      return new_p.toFixed(2);
    },

    getCoupon() {
      //console.log("get:" + store.state.couponid);
      return store.state.couponid;
    },
    onAddCart2(item, index1, index2, index3) {
      var sku = {};
      var obj = item.list[index1].skus[index2].opt[index3];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = item.list[index1].h2;

      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });

      if (this.adaptor == 1) {
        let adaptor_us = store.state.inventory.adaptor_us;
        adaptor_us.metadata = {};
        adaptor_us.metadata.image0 = adaptor_us.images[0];
        list.push({ sku: adaptor_us, quantity: 1 });
      } else if (this.adaptor == 2) {
        let adaptor_au = store.state.inventory.adaptor_au;
        adaptor_au.metadata = {};
        adaptor_au.metadata.image0 = adaptor_au.images[0];
        list.push({ sku: adaptor_au, quantity: 1 });
      }

      storage.onAddCart(list, this);
    },
    onAddCart(prod_index) {
      var sku = {};
      var obj =
        this.inventory[prod_index].list[this.inventory[prod_index].index];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = this.inventory[prod_index].h1;
      if (prod_index == 3 && this.inventory[prod_index].index < 2) {
        sku.productname = this.inventory[prod_index].h1b;
      }
      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });
      storage.onAddCart(list, this);
    },
    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    storage.clearstorestate();
    //storage.populateSku(this, 1);
    storage.processCoupon();
    storage.saveCart2Store(this);

    var delayInMilliseconds = 200; //1 second

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, delayInMilliseconds);
  },
};
</script>

<style lang="scss">
.bundle-cell {
  max-width: 20%;
  padding-left: 0;
  padding-right: 10px;
}

.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #fec131;
  background-color: white;
}

.bundle-h1 span,
.bundle-h1 {
  font-size: 30px;
  font-weight: 700;
}

.bundle-h2 span,
.bundle-h2 {
  font-size: 20px;
  font-weight: 700;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
.tile-header {
  border-radius: 10px 10px 0 0;
  color: white;
  text-align: center;
  font-weight: 600;
}

.bundle-container {
  background-color: white;
  border-radius: 0 0 10px 10px;
  margin: 0 auto;
  max-width: 340px;
  padding-bottom: 30px;
}

.bundle-item-container {
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-bottom: 6px;
  cursor: pointer;
  border: 2px solid;
  border-color: #f8f8f8;
  min-height: 55px !important;
}

.bundle-add-cart,
.bundle-add-cart:hover {
  background-color: white;
  color: #12b8ed;
  border-color: #12b8ed;
  padding-left: 20px;
  border: 2px solid;
  padding-right: 20px;
  font-weight: 600;
}

.selected-border {
  border: 3px solid !important;
  border-color: #fec131 !important;
  border-radius: 10px;
}

.unselected-border {
  border: 2px solid;
  border-color: #dfe0e1;
  border-radius: 10px;
}

.bundle-item {
  padding-top: 5px;
  padding-bottom: 5px;
}

@media (max-width: 1199px) {
}
@media (min-width: 1200px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
}

.image_bundle {
  padding: 5%;
}

@media (max-width: 768px) {
  .reduced-margin-top{
    margin-top:30px!important
  }
  .bundle-cell {
    max-width: 25%;
    padding-left: 2px;
    padding-right: 5px;
  }

  .max-width-sm {
    width: 100% !important;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
  }
  .bundle-h1 span,
  .bundle-h1 {
    font-size: 26px;
    font-weight: 700;
  }

  .bundle-h2 span,
  .bundle-h2 {
    font-size: 16px;
    font-weight: 700;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .image_bundle {
    padding: 0;
  }

  .bundle-item-container {
    max-width: 100%;
  }
}
</style>